import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import CaseStudy from './CaseStudy';
import './CaseStudy.css';

const CaseStudyList = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs-list-page">
      <Header />
      <div className='list-section'>
        <CaseStudy showHeading={true} showViewAll={false} />
      </div>
      <Footer />
    </div>
  );
};

export default CaseStudyList;
